import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

// style
import './style.scss';

@inject('commonStore')
@observer
export default class Loading extends React.Component {
    render() {
        let { overwrite } = this.props;
        let { isLoading } = this.props.commonStore;

        if(overwrite || isLoading){
            return (
                <div id="loading-overlay">
                    <div className="lds-facebook"><div></div><div></div><div></div></div>
                </div>
            );
        } else {
            return null;
        }
    }
}
